import React from 'react';

import ImgIconComp from '../imgcomp';
import { withTranslation } from 'react-i18next';

class MeetingAttendeeOpts extends React.Component {
  constructor(props) {
    super(props);
    this.makeAttendeeAdmin = this.makeAttendeeAdmin.bind(this);
    this.removeMeetingAttendee = this.removeMeetingAttendee.bind(this);
  }

  makeAttendeeAdmin(meetingId, userId, isAdmin) {
    const _this = this;
    const isAdminVal = isAdmin == 1 ? 0 : 1;
    $.ajax({
      url: `${wbConfig.baseUrl}/meeting/roleModifyMeetingInvitee`,
      type: 'post',
      data: { meetingId, userId, isAdmin: isAdminVal },
    })
      .done((response) => {
        if (response.error) {
          console.log(response.error);
        } else {
          _this.props.updateMeetingInviteeAccess(userId, isAdminVal);
        }
      });
  }

  removeMeetingAttendee(meetingId, userId) {
    const _this = this;
    $.ajax({
      url: `${wbConfig.baseUrl}/meeting/removeMeetingInvitee`,
      type: 'post',
      data: { meetingId, userId },
    })
      .done((response) => {
        if (response.error) {
          console.log(response.error);
        } else {
          _this.props.removeMeetingInvitee(userId);
        }
      });
  }

  render() {
    const { t } = this.props;;
    return (
      <div className="grpMeetingAttendeeOpts">
        <div className="grpMeetingAttendeeOpt" onClick={() => this.makeAttendeeAdmin(this.props.meetingId, this.props.userId, this.props.isAdmin)}>
          <ImgIconComp class="grpMeetingAdmOptImg" width="20" height="20" id="permissions_img" />
          {
            this.props.isAdmin == 1 ? 'Remove Admin' : 'Make Admin'
          }
        </div>
        <div className="grpMeetingAttendeeOpt" onClick={() => this.removeMeetingAttendee(this.props.meetingId, this.props.userId)}>
          <ImgIconComp class="grpMeetingRmOptImg" width="20" height="20" id="delete_img" />
          {t("Remove")}
        </div>
      </div>
    );
  }
}
export default withTranslation()(MeetingAttendeeOpts);